import {
  MetricRegistry,
  reportColumnIds as contractReportColumnIds,
  type ReportColumnId,
  type ReportMetricId,
} from "@meta-video/contracts";

export type { ReportColumnId };

const hiddenReportColumnIds: ReadonlySet<ReportColumnId> = new Set([
  "aov",
  "cpm",
  "revenue",
]);

export const reportColumnIds: readonly ReportColumnId[] = contractReportColumnIds.filter(
  (columnId) => !hiddenReportColumnIds.has(columnId),
);

export function visibleReportColumnIds(
  columnIds: readonly ReportColumnId[],
): readonly ReportColumnId[] {
  return columnIds.filter((columnId) => !hiddenReportColumnIds.has(columnId));
}

export function hiddenReportColumnPreferences(
  columnIds: readonly ReportColumnId[],
): readonly ReportColumnId[] {
  return columnIds.filter((columnId) => hiddenReportColumnIds.has(columnId));
}

export function reportColumnLabel(columnId: ReportColumnId): string {
  if (columnId === "duration") return "Duration";
  if (columnId === "firstSeen") return "First seen";
  return MetricRegistry[columnId].label;
}

export function isReportMetricColumnId(
  columnId: ReportColumnId,
): columnId is ReportMetricId {
  return Object.hasOwn(MetricRegistry, columnId);
}

export function isVideoCoverageMetric(
  columnId: ReportColumnId,
): columnId is "hookRate" | "holdRate" {
  return columnId === "hookRate" || columnId === "holdRate";
}
